// extracted by mini-css-extract-plugin
export default {"root":"_26X0m","icon":"_1-PyJ","text":"_1pXPv"};